function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Fragment } from 'react';
import { componentsThemeMap } from '../../componentsThemeMap.js';
import { SectionComponentLayout } from '../../layout/SectionComponentLayout.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import '../../ui/Div/index.js';
import { ErrorBoundary } from '../../ui/ErrorBoundary.js';
import '../../ui/RichText/index.js';
import { Text } from '../../ui/Text.js';
import { Row } from './Row.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { RichText } from '../../ui/RichText/RichText.js';
const customComponentsThemeMap = _objectSpread(_objectSpread({}, componentsThemeMap), {}, {
  dark: _objectSpread(_objectSpread({}, componentsThemeMap.dark), {}, {
    backgroundAlternate: 'gray80'
  })
});
function HighlightComparisonTable({
  headline,
  subhead,
  legalDisclaimer,
  hasSpacingTop,
  style = 'default',
  tableStyle = 'alternate',
  anchor,
  rowLabels = [],
  comparisonColumns = []
}) {
  const _customComponentsThem = customComponentsThemeMap[style],
    foreground = _customComponentsThem.foreground,
    foregroundSecondary = _customComponentsThem.foregroundSecondary,
    background = _customComponentsThem.background,
    backgroundAlternate = _customComponentsThem.backgroundAlternate,
    primary = _customComponentsThem.primary;
  const highlightedHeaderColor = style === 'primary' ? background : 'background';
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "HighlightComparisonTable",
      children: /*#__PURE__*/jsx(SectionComponentLayout, {
        hasSpacingHorizontal: true,
        background: background,
        hasSpacingTop: hasSpacingTop,
        hasNonDefaultBackgroundSpacingVertical: true,
        anchor: anchor,
        children: /*#__PURE__*/jsxs(Div, {
          flexDirection: "column",
          alignItems: "center",
          children: [/*#__PURE__*/jsx(Text, {
            variant: {
              sm: 'title2',
              lg: 'display2'
            },
            as: "h2",
            color: foreground,
            css: {
              textAlign: 'center'
            },
            children: headline
          }), subhead && /*#__PURE__*/jsx(Div, {
            flexDirection: "column",
            css: {
              textAlign: 'center'
            },
            children: /*#__PURE__*/jsx(RichText, {
              content: subhead,
              color: foregroundSecondary
            })
          }), /*#__PURE__*/jsxs(Div, {
            display: {
              sm: 'none',
              lg: 'grid'
            },
            justifyContent: "center",
            spacingTop: 7,
            gridTemplateColumns: `repeat(${comparisonColumns.length + 1}, 1fr)`,
            children: [/*#__PURE__*/jsx(Div, {
              as: "span"
            }), comparisonColumns.map((column, index) => {
              return /*#__PURE__*/jsx(Row, {
                isColumnHead: true,
                headline: column.heading,
                subhead: column.subhead,
                foreground: column.highlighted ? highlightedHeaderColor : foreground,
                foregroundSecondary: column.highlighted ? highlightedHeaderColor : foregroundSecondary,
                background: column.highlighted ? primary : background
              }, `column-heading-${index}`);
            }), rowLabels.map((row, index) => /*#__PURE__*/jsxs(Fragment, {
              children: [/*#__PURE__*/jsx(Row, {
                headline: row.label,
                subhead: row.subLabel,
                alignContent: "start",
                foreground: foreground,
                foregroundSecondary: foregroundSecondary,
                background: tableStyle === 'alternate' && index % 2 === 0 ? backgroundAlternate : background
              }, index), comparisonColumns.map((column, columnIndex) => {
                const cell = column.cells[index];
                if (!cell) return /*#__PURE__*/jsx(Div, {
                  as: "span"
                }, `data-${index}-${columnIndex}`);
                return /*#__PURE__*/jsx(Row, {
                  label: cell.heading,
                  subLabel: cell.subhead,
                  hasCheck: cell.hasCheck,
                  isPositiveCheck: cell.isPositiveCheck,
                  bordered: column.highlighted,
                  foreground: foreground,
                  foregroundSecondary: foregroundSecondary,
                  background: tableStyle === 'alternate' && index % 2 === 0 ? backgroundAlternate : background,
                  borderColor: primary
                }, `data-${index}-${columnIndex}`);
              })]
            }, `label-${index}`)), /*#__PURE__*/jsx(Div, {
              as: "span"
            }), comparisonColumns.map((column, index) => {
              return /*#__PURE__*/jsx(Row, {
                ctaLabel: column.ctaLabel,
                ctaUrl: column.ctaUrl,
                ctaVariant: column.highlighted ? style === 'primary' ? 'positive' : 'primary' : 'secondary',
                subLabel: column.underline,
                justifyContent: "start",
                bordered: column.highlighted,
                foregroundSecondary: foregroundSecondary,
                borderedEnd: column.highlighted,
                borderColor: primary
              }, `cta-${index}`);
            })]
          }), /*#__PURE__*/jsx(Div, {
            display: {
              sm: 'flex',
              lg: 'none'
            },
            flexDirection: "column",
            justifyContent: "center",
            spacingTop: 7,
            children: comparisonColumns.map((column, index) => {
              return /*#__PURE__*/jsxs(Div, {
                flexDirection: "column",
                spacingBottom: index !== comparisonColumns.length - 1 ? 7 : 0,
                children: [/*#__PURE__*/jsx(Row, {
                  isColumnHead: true,
                  headline: column.heading,
                  subhead: column.subhead,
                  foreground: column.highlighted ? 'background' : foreground,
                  foregroundSecondary: column.highlighted ? 'background' : foregroundSecondary,
                  background: column.highlighted ? primary : background
                }), column.cells.map((cell, cellIndex) => /*#__PURE__*/jsx(Row, {
                  label: cell.heading,
                  headline: rowLabels[cellIndex].label,
                  subhead: rowLabels[cellIndex].subLabel,
                  subLabel: cell.subhead,
                  hasCheck: cell.hasCheck,
                  bordered: column.highlighted,
                  foreground: foreground,
                  foregroundSecondary: foregroundSecondary,
                  background: tableStyle === 'alternate' && cellIndex % 2 === 0 ? backgroundAlternate : background,
                  borderColor: primary
                }, `data-${index}-${cellIndex}`)), /*#__PURE__*/jsx(Row, {
                  ctaLabel: column.ctaLabel,
                  ctaUrl: column.ctaUrl,
                  ctaVariant: column.highlighted ? style === 'primary' ? 'secondary' : 'primary' : 'secondary',
                  subLabel: column.underline,
                  justifyContent: "start",
                  bordered: column.highlighted,
                  foregroundSecondary: foregroundSecondary,
                  borderedEnd: column.highlighted,
                  borderColor: primary
                })]
              }, `cta-${index}`);
            })
          }), legalDisclaimer && /*#__PURE__*/jsx(Text, {
            spacingTop: 5,
            variant: "legal",
            color: foregroundSecondary,
            as: "p",
            css: {
              whiteSpace: 'break-spaces'
            },
            children: legalDisclaimer
          })]
        })
      })
    })
  });
}
export { HighlightComparisonTable };
//# sourceMappingURL=HighlightComparisonTable.js.map
